module.exports = __webpack_public_path__ + "img/grip-horizontal.7ded050d.svg";